import React from 'react';
import { Box, Paper, Typography, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PageGuideTooltip from '../PageGuideTooltip';

// One wrapping flex row for every KPI card on the Executive Summary and Deep Dive pages.
// Shared cards keep the same order on both: Velocity Multiplier, Win Rate Lift (legacy only),
// Total opportunity value, Total Won; page-specific cards follow.
// Long dollar amounts ($2,057,332,739) overflow a card at the h4 size; step the font down by length instead of clipping.
export function kpiValueSize(value) {
  const len = typeof value === 'string' ? value.length : 0;
  if (len > 13) return { fontSize: '1.45rem' };
  if (len > 10) return { fontSize: '1.75rem' };
  return {};
}

export function ExecKpiRow({ children }) {
  return <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2 }}>{children}</Box>;
}

export function ExecKpiSlot({ basis = 180, children }) {
  return (
    <Box sx={{ flex: `1 1 ${basis}px`, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
      {children}
    </Box>
  );
}

export function KpiTile({ label, value, sub, sub2, muted, mutedTooltip, color, 'aria-label': ariaLabel, tooltip, metricKey, onClick, valueStyle }) {
  return (
    <Paper
      elevation={2}
      aria-label={ariaLabel || label}
      onClick={onClick}
      sx={{
        p: 2.5, height: '100%', display: 'flex', flexDirection: 'column', gap: 0.5,
        ...(onClick ? { cursor: 'pointer', '&:hover': { boxShadow: 4 } } : {}),
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, letterSpacing: 0.5, textTransform: 'uppercase' }}>
          {label}
        </Typography>
        {tooltip && (metricKey ? (
          <PageGuideTooltip title={label} description={tooltip} metricKey={metricKey} />
        ) : (
          <Tooltip title={tooltip} placement="top" arrow>
            <InfoOutlinedIcon fontSize="small" color="action" sx={{ mt: -0.25, flexShrink: 0 }} />
          </Tooltip>
        ))}
      </Box>
      <Typography variant="h4" sx={{ fontWeight: 700, color: color || 'text.primary', ...kpiValueSize(value), ...valueStyle }}>
        {value}
      </Typography>
      {sub && <Typography variant="caption" color="text.secondary">{sub}</Typography>}
      {sub2 && <Typography variant="caption" color="text.secondary">{sub2}</Typography>}
      {muted && (
        <Tooltip title={mutedTooltip || ''} placement="bottom" arrow>
          <Typography variant="caption" color="text.disabled" data-testid="kpi-muted-line">{muted}</Typography>
        </Tooltip>
      )}
    </Paper>
  );
}
